import DataAccess from "../DataAccessStrategy";

export default class DespesaVeiculo extends DataAccess {
  constructor() {
    super("DespesaVeiculo", {
      id: Number,
      shouldSync: Boolean,
      updatedDate: Date,
      numeroDocumento: String,
      fornecedor: String,
      viagem: String,
      item: String,
      valor: String,
      ativo: Boolean,
      quilometragem: String,
      VeiculoId: Number,
      hashRotaAbertura: String,
      hash: String,
    });
    this.filterDifferentHashRotaAbertura =
      this.filterDifferentHashRotaAbertura.bind(this);
    this.filterByHashRotaAbertura = this.filterByHashRotaAbertura.bind(this);
  }
  async filterDifferentHashRotaAbertura(routeOpening) {
    if (routeOpening) {
      return await this.model
        .where("hashRotaAbertura")
        .notEqual(routeOpening.hash)
        .filter((a) => a.ativo != false)
        .toArray();
    } else {
      return await this.model.toArray();
    }
  }
  async filterByHashRotaAbertura(routeOpening) {
    if (routeOpening) {
      return await this.model
        .where("hashRotaAbertura")
        .equals(routeOpening.hash)
        .filter((a) => a.ativo != false)
        .toArray();
    } else {
      return await this.model.toArray();
    }
  }
}
